import { supabase } from '../supabase';

export const getMessages = async (clientId) => {
  const { data, error } = await supabase
    .from('coach_client_messages')
    .select('id, sender_id, sender_role, message, created_at, read_at')
    .eq('client_id', clientId)
    .order('created_at', { ascending: true });

  if (error) throw error;
  return data || [];
};

export const sendMessage = async (clientId, senderRole, message) => {
  const { data: { user } } = await supabase.auth.getUser();
  if (!user) throw new Error('Not logged in');

  const { error } = await supabase
    .from('coach_client_messages')
    .insert({ client_id: clientId, sender_id: user.id, sender_role: senderRole, message });

  if (error) throw error;
};

// Marks the OTHER party's messages as read (a client reading marks 'coach'
// messages read; a coach reading marks 'client' messages read).
export const markMessagesRead = async (clientId, readerRole) => {
  const otherRole = readerRole === 'client' ? 'coach' : 'client';
  const { error } = await supabase
    .from('coach_client_messages')
    .update({ read_at: new Date().toISOString() })
    .eq('client_id', clientId)
    .eq('sender_role', otherRole)
    .is('read_at', null);

  if (error) throw error;
};

// Batch unread count per client, for the coach's Manage Clients list badges.
export const getUnreadCountsForClients = async (clientIds) => {
  if (!clientIds || clientIds.length === 0) return {};
  const { data, error } = await supabase
    .from('coach_client_messages')
    .select('client_id')
    .in('client_id', clientIds)
    .eq('sender_role', 'client')
    .is('read_at', null);

  if (error) throw error;
  const counts = {};
  (data || []).forEach(row => {
    counts[row.client_id] = (counts[row.client_id] || 0) + 1;
  });
  return counts;
};

// Unread client messages per client, with the newest one's time (set by the database), for
// "Needs you": a Clear hides only messages up to the newest one the coach was shown.
export const getUnreadForClients = async (clientIds) => {
  if (!clientIds || clientIds.length === 0) return {};
  const { data, error } = await supabase
    .from('coach_client_messages')
    .select('client_id, created_at')
    .in('client_id', clientIds)
    .eq('sender_role', 'client')
    .is('read_at', null);

  if (error) throw error;
  const out = {};
  (data || []).forEach(row => {
    const o = out[row.client_id] || (out[row.client_id] = { count: 0, newest: null });
    o.count += 1;
    if (row.created_at && (!o.newest || row.created_at > o.newest)) o.newest = row.created_at;
  });
  return out;
};

// Which of these clients the coach has ever written to, for "Needs you today" (a new client the
// coach has not greeted yet). Asked only about clients who joined in the last week.
export const getClientsTheCoachHasWritten = async (clientIds) => {
  if (!clientIds || clientIds.length === 0) return {};
  const { data, error } = await supabase
    .from('coach_client_messages')
    .select('client_id')
    .in('client_id', clientIds)
    .eq('sender_role', 'coach');

  if (error) throw error;
  const written = {};
  (data || []).forEach(row => { written[row.client_id] = true; });
  return written;
};

// Single unread count for the client's own BottomNav badge.
export const getUnreadCoachMessageCount = async (clientId) => {
  const { count, error } = await supabase
    .from('coach_client_messages')
    .select('id', { count: 'exact', head: true })
    .eq('client_id', clientId)
    .eq('sender_role', 'coach')
    .is('read_at', null);

  if (error) throw error;
  return count || 0;
};
